var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.785611 1.65861L3.62944 4.97729C3.67528 5.03076 3.73214 5.07368 3.79613 5.1031C3.86011 5.13252 3.9297 5.14776 4.00013 5.14776C4.07055 5.14776 4.14015 5.13252 4.20413 5.1031C4.26811 5.07368 4.32498 5.03076 4.37082 4.97729L7.21465 1.65861C7.48605 1.34184 7.26103 0.852539 6.84396 0.852539H1.15548C0.738411 0.852539 0.513394 1.34184 0.785611 1.65861Z",
    fill: "#EE7F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleArrowDown);
export default __webpack_public_path__ + "static/media/triangleArrowDown.019c06ce791812ab1efc63b5868f8d3c.svg";
export { ForwardRef as ReactComponent };